import classNames from 'classnames'
import { Button, Select, SelectButton, SelectButtonCaret, SelectDropdown } from 'journey-ui'
import React, { useContext } from 'react'
import { ItemPageContext } from '../../contexts/ItemPageContext'
import { capitalize } from '../../helpers'
import { ToppingContext } from '../../contexts/ToppingContext'
import { AppContext } from '../../contexts/AppContext'

const HAHPie = ({ type, w = 16, h = 16 }: { w?: number, h?: number, type: 'whole' | 'left' | 'right' }) => (
  <div
    className={classNames(
      'rounded-full border border-red-500 relative flex items-center',
      { 'justify-center': type === 'whole', 'justify-end': type === 'right', 'justify-start': type === 'left' },
    )}
    style={{ height: h + 4, width: w + 4 }}
  >
    {type === 'whole' ? <div className="bg-red-500 rounded-full" style={{ height: h, width: w }} /> : null}
    {type === 'left' ? <div className="bg-red-500 ml-[1px] rounded-l-full" style={{ height: h, width: w / 2 }} /> : null}
    {type === 'right' ? <div className="bg-red-500 mr-[1px] rounded-r-full" style={{ height: h, width: w / 2 }} /> : null}
  </div>
)

interface Props {

}

const sideNumbers = {
  0: 'whole',
  1: 'left',
  2: 'right',
}

export const HalfAndHalfSelect: React.FC<Props> = () => {
  const { topping } = useContext(ToppingContext)
  const { brand } = useContext(AppContext)
  const { form, item, setForm } = useContext(ItemPageContext)

  const onSideClick = (newSide: number) => {
    setForm((form) => ({
      ...form,
      toppings: form.toppings.map((t) => {
        if (t.hash_id === topping.hash_id) {
          let newPrice = t.price

          /* If we are moving to half/half, divide the price */
          if (newSide !== 0 && t.side === 0) {
            newPrice *= brand.hnh_discount_percent
          }

          /* If we are moving back to whole, multiply the price. */
          if (newSide === 0 && t.side !== 0) {
            newPrice = t.section_topping_price
          }

          return {
            ...t,
            side: newSide,
            price: newPrice,
          }
        }

        return t
      }),
    }))
  }

  return (
    <Select className="flex-grow-0">
      <SelectButton className="px-3 py-1 min-h-0 space-x-2">
        <HAHPie w={12} h={12} type={sideNumbers[topping.side]} />
        <span className="text-xs">{capitalize(sideNumbers[topping.side])}</span>
        <SelectButtonCaret className="w-3 h-3" />
      </SelectButton>
      <SelectDropdown>
        <Button className="border-none rounded-none space-x-2 w-full" onClick={() => onSideClick(0)}>
          <HAHPie type="whole" />
          <span>Whole</span>
        </Button>
        <Button className="border-none rounded-none space-x-2 w-full" onClick={() => onSideClick(1)}>
          <HAHPie type="left" />
          <span>Left</span>
        </Button>
        <Button className="border-none rounded-none space-x-2 w-full" onClick={() => onSideClick(2)}>
          <HAHPie type="right" />
          <span>Right</span>
        </Button>
      </SelectDropdown>
    </Select>
  )
}
